import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  NbComponentStatus,
  NbDialogRef,
  NbDialogService,
  NbGlobalPhysicalPosition,
  NbTagComponent,
  NbTagInputAddEvent,
  NbToastrService,
} from "@nebular/theme";
import * as _ from "lodash";
import { remove } from "lodash";
import Announcement from "../../models/announcement.model";
import { AnnouncementService } from "../../services/announcement.service";
import { DialogImagesUploadComponent } from "../dialog-images-upload/dialog-images-upload.component";

@Component({
  selector: "ngx-dialog-announcement",
  templateUrl: "dialog-announcement.component.html",
  styleUrls: ["dialog-announcement.component.scss"],
})
export class DialogAnnouncementComponent implements OnInit {
  @Input() header: string;
  @Input() mode: string; //admin / course / home
  @Input() announcement: Announcement = new Announcement();

  status: string = "0";
  trees: Set<string> = new Set([]);
  diaForm: FormGroup;
  submitted = false;
  loading = false;
  edited = false;
  imageURL = "";
  imagesUrl = [];
  menu = "info";
  bkContent = "";

  constructor(
    protected ref: NbDialogRef<DialogAnnouncementComponent>,
    private fb: FormBuilder,
    private announcementService: AnnouncementService,
    private toastrService: NbToastrService,
    private dialogService: NbDialogService
  ) {}

  ngOnInit() {
    const titleValidators = [
      Validators.minLength(3),
      Validators.maxLength(250),
      Validators.required,
    ];

    const descriptionValidators = [
      Validators.minLength(3),
      Validators.maxLength(500),
      Validators.required,
    ];

    this.diaForm = this.fb.group({
      title: ["", titleValidators],
      description: ["", descriptionValidators],
    });

    if (this.announcement.tags && this.announcement.tags.length > 0) {
      var trees = new Set([]);
      this.announcement.tags.forEach(function (value) {
        trees.add(value);
      });
      this.trees = trees;
    } else {
      this.trees.add("Thông báo");
    }

    if (!this.announcement.sourceType) {
      this.announcement.sourceType = "document";
    }
    if (!this.announcement.status) {
      this.status = "1";
    } else {
      this.status = this.announcement.status.toString();
    }

    if (this.announcement.coverUrl && this.announcement.coverUrl != "") {
      this.imageURL = this.announcement.coverUrl;
    }
    if (this.announcement.imagesUrl && this.announcement.imagesUrl.length > 0) {
      this.imagesUrl = _.clone(this.announcement.imagesUrl);
    }
    if (!this.announcement.content) {
      this.announcement.content = "";
    } else {
      this.bkContent = this.announcement.content;
    }

    if (
      this.announcement.privacy == null ||
      this.announcement.privacy == undefined
    ) {
      this.announcement.privacy = false;
    }
    if (
      this.announcement.newComment == null ||
      this.announcement.newComment == undefined
    ) {
      this.announcement.newComment = true;
    }
    if (
      this.announcement.showComments == null ||
      this.announcement.showComments == undefined
    ) {
      this.announcement.showComments = true;
    }
  }

  cancel() {
    if (this.edited) {
      this.ref.close(this.announcement);
    } else {
      this.ref.close();
    }
  }

  selectMenu(value) {
    this.menu = value;
  }

  submit() {
    this.submitted = true;

    var tags: string[] = [];
    this.trees.forEach(function (item) {
      tags.push(item);
    });
    this.announcement.tags = tags;
    this.announcement.status = parseInt(this.status);

    if (this.mode == "edit") {
      this.edit();
    } else {
      this.create();
    }
  }

  create() {
    this.loading = true;
    this.submitted = true;

    this.announcementService
      .create(this.announcement)
      .then((data) => {
        this.announcement = data;

        this.loading = false;
        this.submitted = false;

        this.ref.close(this.announcement);
      })
      .catch((err) => {
        this.loading = false;
        this.submitted = false;
      });
  }

  edit() {
    this.loading = true;
    this.submitted = true;
    var subscribe: any;
    if (this.announcement.content != this.bkContent) {
      subscribe = this.announcementService.update(this.announcement);
    } else {
      subscribe = this.announcementService.updateInfo(this.announcement);
    }
    subscribe
      .then((data) => {
        this.loading = false;
        this.submitted = false;

        this.edited = true;
        this.showToast("success", "Cập nhật bài viết", "thành công");
      })
      .catch((err) => {
        this.loading = false;
        this.submitted = false;
        this.showToast("warning", "Cập nhật bài viết", "thất bại");
      });
  }

  //Images
  openGallery() {
    this.dialogService
      .open(DialogImagesUploadComponent, {
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.addImage(value);
        }
      });
  }

  updateImage(imageUrl) {
    if (imageUrl && imageUrl != "") {
      this.announcement.coverUrl = imageUrl;
      this.imageURL = imageUrl.replace("_400x400", "");
    }
  }
  removeCoverUrl() {
    this.announcement.coverUrl = "";
    this.imageURL =
      "https://kasoft-learning.s3.ap-southeast-1.amazonaws.com/assets/images/image-upload-bg.jpg";
  }

  addImage(obj) {
    let imageURL = obj.value;

    if (!this.announcement.imagesUrl) {
      this.announcement.imagesUrl = [];
    }
    this.announcement.imagesUrl.push(imageURL);

    if (obj.isNew) {
      imageURL = imageURL.replace("_400x400", "");
    }
    this.imagesUrl.push(imageURL);
  }

  deleteImage(item) {
    remove(this.announcement.imagesUrl, (el) => {
      return el == item;
    });
  }

  //Tags
  onTagRemove(tagToRemove: NbTagComponent): void {
    this.trees.delete(tagToRemove.text);
  }

  onTagAdd({ value, input }: NbTagInputAddEvent): void {
    if (value) {
      this.trees.add(value.trim().toUpperCase());
    }
    input.nativeElement.value = "";
  }

  // control event
  private showToast(type: NbComponentStatus, title: string, body: string) {
    const config = {
      status: type,
      destroyByClick: true,
      duration: 2000,
      hasIcon: true,
      position: NbGlobalPhysicalPosition.TOP_RIGHT,
      preventDuplicates: false,
    };
    const titleContent = title ? `${title}` : "";

    this.toastrService.show(body, titleContent, config);
  }
}
